export default __webpack_public_path__ + "static/media/dtmf-star.8ea37e33.mp3";